// src/components/InboundKPI.tsx
import React, { useMemo } from 'react';
import { Row, Col } from 'antd';
import { InboxOutlined, CalendarOutlined, FieldTimeOutlined } from '@ant-design/icons';
import StatCard from './StatCard';
import { useInbounds } from '../hooks/useInbounds';
import { D, W, M, Y, currPrevCount, pct } from '../utils/kpi';

type Inbound = { createdAt: string };

type Props = {
  /** (опц.) Отфильтрованный источник — чтобы KPI совпадал с таблицей/донатом */
  source?: Inbound[];
  /** Показать карточку «за всё время» (по умолчанию — нет) */
  showAllTime?: boolean;
};

const fmt = (n: number) => n.toLocaleString('ru-RU');

const InboundKPI: React.FC<Props> = ({ source, showAllTime = false }) => {
  const hook = useInbounds(10_000);
  const items = source ?? hook.items;

  const data = useMemo(
    () => ({
     d: currPrevCount(items, D),
     w: currPrevCount(items, W),
     m: currPrevCount(items, M),
     y: currPrevCount(items, Y),
      all: { curr: items.length, prev: 0 },
    }),
    [items]
  );

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={12} lg={6}>
        <StatCard
          className="stat-card--kpi"
          accent
          icon={<FieldTimeOutlined />}
          title="Поступления (24 часа)"
          value={fmt(data.d.curr)}
          suffix="шт"
          linkText="Отчёт"
          onLink={() => {}}
          deltaText={pct(data.d.curr, data.d.prev)}
          deltaHint="vs вчера"
        />
      </Col>

      <Col xs={24} md={12} lg={6}>
        <StatCard
          className="stat-card--kpi"
          accent
          icon={<CalendarOutlined />}
          title="Поступления (неделя)"
          value={fmt(data.w.curr)}
          suffix="шт"
          linkText="Отчёт"
          onLink={() => {}}
          deltaText={pct(data.w.curr, data.w.prev)}
          deltaHint="vs прошл. неделя"
        />
      </Col>

      <Col xs={24} md={12} lg={6}>
        <StatCard
          className="stat-card--kpi"
          accent
          icon={<CalendarOutlined />}
          title="Поступления (месяц)"
          value={fmt(data.m.curr)}
          suffix="шт"
          linkText="Отчёт"
          onLink={() => {}}
          deltaText={pct(data.m.curr, data.m.prev)}
          deltaHint="vs прошл. месяц"
        />
      </Col>

      <Col xs={24} md={12} lg={6}>
        <StatCard
          className="stat-card--kpi"
          accent
          icon={<CalendarOutlined />}
          title="Поступления (год)"
          value={fmt(data.y.curr)}
          suffix="шт"
          linkText="Отчёт"
          onLink={() => {}}
          deltaText={pct(data.y.curr, data.y.prev)}
          deltaHint="vs прошл. год"
        />
      </Col>

      {showAllTime && (
        <Col xs={24} md={12} lg={6}>
          <StatCard
            className="stat-card--kpi"
            blueAccent
            icon={<InboxOutlined />}
            title="Поступления (за всё время)"
            value={fmt(data.all.curr)}
            suffix="шт"
            linkText="Детализация"
            onLink={() => {}}
          />
        </Col>
      )}
    </Row>
  );
};

export default InboundKPI;
